var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useRef, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Select } from "@opala-ds/react";
import { z } from "zod";
import ReCAPTCHA from "react-google-recaptcha";
import CoachRegistrationProofSearchForm from "./CoachRegistrationProofSearchForm";
import SchoolIndividualRegistrationRegistrationProofSearchForm from "./SchoolIndividualRegistrationRegistrationProofSearchForm";
import SchoolTeamRegistrationRegistrationProofSearchForm from "./SchoolTeamRegistrationRegistrationProofSearchForm";
import StudentAthleteRegistrationProofSearchForm from "./StudentAthleteRegistrationProofSearchForm";
import { RequiredStringSchema, OptionalStringSchema, REQUIRED_MESSAGE, } from "../../utils/schemas";
import { removeCpfMask, removeDateMask } from "../../utils/format";
import useSearchStore from "../../stores/searchStore";
import { useHistory } from "react-router-dom";
var Schema = z
    .object({
    tipoInscricao: RequiredStringSchema,
    studentAthlete: z
        .object({
        cpf: OptionalStringSchema,
        codigoInscricao: OptionalStringSchema,
        dataNascimento: OptionalStringSchema,
    })
        .optional(),
    coach: z
        .object({
        cpf: OptionalStringSchema,
        codigoInscricao: OptionalStringSchema,
        dataNascimento: OptionalStringSchema,
    })
        .optional(),
    schoolIndividualRegistration: z
        .object({
        inep: OptionalStringSchema,
        codigoInscricao: OptionalStringSchema,
    })
        .optional(),
    schoolTeamRegistration: z
        .object({
        inep: OptionalStringSchema,
        codigoInscricao: OptionalStringSchema,
    })
        .optional(),
})
    .superRefine(function (data, ctx) {
    if (data.tipoInscricao === "STUDENT_ATHLETE") {
        if (!data.studentAthlete) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Dados do estudante/atleta são obrigatórios",
                path: ["studentAthlete"],
            });
            return;
        }
        if (!data.studentAthlete.cpf) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["studentAthlete", "cpf"],
            });
        }
        if (!data.studentAthlete.codigoInscricao) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["studentAthlete", "codigoInscricao"],
            });
        }
        if (!data.studentAthlete.dataNascimento) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["studentAthlete", "dataNascimento"],
            });
        }
    }
    if (data.tipoInscricao === "COACH") {
        if (!data.coach) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Dados do técnico/dirigente são obrigatórios",
                path: ["coach"],
            });
            return;
        }
        if (!data.coach.cpf) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["coach", "cpf"],
            });
        }
        if (!data.coach.codigoInscricao) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["coach", "codigoInscricao"],
            });
        }
        if (!data.coach.dataNascimento) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["coach", "dataNascimento"],
            });
        }
    }
    if (data.tipoInscricao === "SCHOOL_INDIVIDUAL_REGISTRATION") {
        if (!data.schoolIndividualRegistration) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Dados da escola são obrigatórios",
                path: ["schoolIndividualRegistration"],
            });
            return;
        }
        if (!data.schoolIndividualRegistration.inep) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["schoolIndividualRegistration", "inep"],
            });
        }
        if (!data.schoolIndividualRegistration.codigoInscricao) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["schoolIndividualRegistration", "codigoInscricao"],
            });
        }
    }
    if (data.tipoInscricao === "SCHOOL_TEAM_REGISTRATION") {
        if (!data.schoolTeamRegistration) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Dados da escola são obrigatórios",
                path: ["schoolTeamRegistration"],
            });
            return;
        }
        if (!data.schoolTeamRegistration.inep) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["schoolTeamRegistration", "inep"],
            });
        }
        if (!data.schoolTeamRegistration.codigoInscricao) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: ["schoolTeamRegistration", "codigoInscricao"],
            });
        }
    }
});
export default function RegistrationProofSearchForm() {
    var _this = this;
    var applySearch = useSearchStore(function (state) { return state.applySearch; });
    var history = useHistory();
    var recaptchaRef = useRef(null);
    var _a = useState(false), isVerified = _a[0], setIsVerified = _a[1];
    var _b = useForm({
        defaultValues: {
            tipoInscricao: "STUDENT_ATHLETE",
        },
        resolver: zodResolver(Schema),
    }), control = _b.control, watch = _b.watch, handleSubmit = _b.handleSubmit, register = _b.register, _c = _b.formState, errors = _c.errors, restFormState = __rest(_c, ["errors"]), restForm = __rest(_b, ["control", "watch", "handleSubmit", "register", "formState"]);
    var tipoInscricaoValue = watch("tipoInscricao");
    var renderSearchFields = useMemo(function () {
        if (tipoInscricaoValue === "STUDENT_ATHLETE")
            return _jsx(StudentAthleteRegistrationProofSearchForm, {});
        if (tipoInscricaoValue === "COACH")
            return _jsx(CoachRegistrationProofSearchForm, {});
        if (tipoInscricaoValue === "SCHOOL_INDIVIDUAL_REGISTRATION")
            return _jsx(SchoolIndividualRegistrationRegistrationProofSearchForm, {});
        if (tipoInscricaoValue === "SCHOOL_TEAM_REGISTRATION")
            return _jsx(SchoolTeamRegistrationRegistrationProofSearchForm, {});
        return null;
    }, [tipoInscricaoValue]);
    function handleVerifyChange() {
        setIsVerified(function (prevState) { return !prevState; });
    }
    return (_jsx(FormProvider, __assign({ control: control, watch: watch, handleSubmit: handleSubmit, register: register, formState: __assign({ errors: errors }, restFormState) }, restForm, { children: _jsxs("form", __assign({ className: "w-full flex flex-col items-start space-y-4", onSubmit: handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                return __generator(this, function (_l) {
                    if (data.tipoInscricao === "STUDENT_ATHLETE") {
                        applySearch({
                            tipoInscricao: data.tipoInscricao,
                            codigoInscricao: (_a = data.studentAthlete) === null || _a === void 0 ? void 0 : _a.codigoInscricao,
                            cpf: removeCpfMask((_b = data.studentAthlete) === null || _b === void 0 ? void 0 : _b.cpf),
                            dataNascimento: removeDateMask((_c = data.studentAthlete) === null || _c === void 0 ? void 0 : _c.dataNascimento),
                        });
                    }
                    if (data.tipoInscricao === "COACH") {
                        applySearch({
                            tipoInscricao: data.tipoInscricao,
                            codigoInscricao: (_d = data.coach) === null || _d === void 0 ? void 0 : _d.codigoInscricao,
                            cpf: removeCpfMask((_e = data.coach) === null || _e === void 0 ? void 0 : _e.cpf),
                            dataNascimento: removeDateMask((_f = data.coach) === null || _f === void 0 ? void 0 : _f.dataNascimento),
                        });
                    }
                    if (data.tipoInscricao === "SCHOOL_INDIVIDUAL_REGISTRATION") {
                        applySearch({
                            tipoInscricao: data.tipoInscricao,
                            codigoInep: (_g = data.schoolIndividualRegistration) === null || _g === void 0 ? void 0 : _g.inep,
                            codigoInscricao: (_h = data.schoolIndividualRegistration) === null || _h === void 0 ? void 0 : _h.codigoInscricao,
                        });
                    }
                    if (data.tipoInscricao === "SCHOOL_TEAM_REGISTRATION") {
                        applySearch({
                            tipoInscricao: data.tipoInscricao,
                            codigoInep: (_j = data.schoolTeamRegistration) === null || _j === void 0 ? void 0 : _j.inep,
                            codigoInscricao: (_k = data.schoolTeamRegistration) === null || _k === void 0 ? void 0 : _k.codigoInscricao,
                        });
                    }
                    history.push("/comprovante");
                    return [2 /*return*/];
                });
            }); }) }, { children: [_jsx("p", __assign({ className: "font-semibold text-base md:text-xl tracking-tight text-[#262626]" }, { children: "J\u00E1 fez sua inscri\u00E7\u00E3o? Busque seu comprovante no campo abaixo:" })), _jsxs("div", __assign({ className: "w-full grid grid-cols-1 md:grid-cols-4 md:gap-x-4 gap-y-4" }, { children: [_jsx(Controller, { control: control, name: "tipoInscricao", render: function (_a) {
                                var _b, _c;
                                var field = _a.field;
                                return (_jsx(Select, { label: "Tipo de inscri\u00E7\u00E3o", placeholder: "Selecione", size: "md", items: [
                                        { label: "Estudante/atleta", value: "STUDENT_ATHLETE" },
                                        { label: "Técnico/dirigente", value: "COACH" },
                                        {
                                            label: "Escola - Modalidade individual",
                                            value: "SCHOOL_INDIVIDUAL_REGISTRATION",
                                        },
                                        {
                                            label: "Escola - Modalidade coletiva",
                                            value: "SCHOOL_TEAM_REGISTRATION",
                                        },
                                    ], containerClassName: field.value && "[&>button>div]:text-[#262626]", value: field.value, onValueChange: field.onChange, helperText: (_c = (_b = errors.tipoInscricao) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "", variant: errors.tipoInscricao ? "critical" : "default" }));
                            } }), renderSearchFields] })), _jsxs("div", __assign({ className: "w-full flex flex-col-reverse md:flex-row-reverse items-center md:items-end gap-4 mt-4" }, { children: [_jsx(Button, __assign({ className: "w-full md:w-max px-6", rightIcon: "Search", disabled: !isVerified, type: "submit" }, { children: "Buscar" })), _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: "6Lf1wlwnAAAAABXuwppJEzCvV_NIdD2lXZL9gbyj", onChange: handleVerifyChange })] }))] })) })));
}
